import { useMemo } from "react";
import { agruparPorCategoria } from "../lib/agrupar";
import CabecalhoCmv from "./CabecalhoCmv";
import LinhaCategoria from "./LinhaCategoria";
import LinhaProduto from "./LinhaProduto";

/**
 * CMV agrupado por categoria. Cada categoria mostra o custo total do que vendeu
 * em 30 dias; clicar abre os produtos dela, na mesma ordem das colunas.
 * Com busca ativa, as categorias com resultado abrem sozinhas.
 */
export default function TabelaCategorias({ linhas, sort, onSort, abertas, onToggle, buscando }) {
  const categorias = useMemo(() => agruparPorCategoria(linhas, sort), [linhas, sort]);
  return (
    <table className="w-full text-sm">
      <CabecalhoCmv sort={sort} onSort={onSort} primeiraColuna="Categoria / produto" />
      <tbody>
        {categorias.map((c) => {
          const aberta = buscando || abertas.has(c.name);
          return [
            <LinhaCategoria key={c.id} c={c} aberta={aberta} onToggle={() => onToggle(c.name)} />,
            ...(aberta ? c.produtos.map((p) => <LinhaProduto key={p.id} p={p} recuado />) : []),
          ];
        })}
      </tbody>
    </table>
  );
}
